<template>
  <div class="body-wrapper table-poll">
    <div class="table-wrapper">
      <spinner
        class="spinner"
        line-fg-color="#00796b"
        :size="100"
        :line-size="6"
        v-if="loading"
      ></spinner>
      <div v-show="!loading">
        <button
          v-if="$router.history.current.name == 'communityPolls'"
          @click="showModal('ModalContentPoll')"
          class="btn"
        >
          Novo glasanje
        </button>
        <checkbox
          class="polls-filter"
          :checked="pollsFilter"
          label="Prikaži samo moja glasanja"
          @change="processFilterChange"
        ></checkbox>
        <data-table
          :columns="tableColumns"
          :tableData="tableData"
          :options="tableOptions"
          :slotNameActionPoll="'action'"
          :slotNamePostPin="'pin'"
        ></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { mapMutations, mapState, mapActions } from 'vuex';
import checkbox from '@/components/common/Checkbox';
export default {
  components: {
    DataTable,
    checkbox
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['modalVisible']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions'])
  },
  created() {
    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('far fa-chart-bar');

    //setting up table options and table column names

    if (this.$router.history.current.name == 'communityPolls') {
      this.initTable('pollTable');
    } else {
      this.initTable('tableAllPolls');
    }
  },
  destroyed() {
    this.setTableBadge('');
  },
  data() {
    return {
      pollsFilter: false
    };
  },
  methods: {
    ...mapActions('table', ['initTable', 'getPollsByCommunity', 'getAllPolls']),
    ...mapMutations('modal', ['showModal']),

    ...mapMutations('table', ['setTableBadge', 'unsetTableData']),
    processFilterChange() {
      switch (this.$router.history.current.name) {
        case 'communityPolls':
          this.getCommunityPolls();
          break;
        case 'polls':
          this.getPollsForAllCommunities();
          break;
        default:
          break;
      }
    },
    async getCommunityPolls() {
      if (this.pollsFilter) {
        await this.getPollsByCommunity({
          communityId: this.$store.getters.getActiveCommunity.id
        });
      } else {
        await this.getPollsByCommunity({
          communityId: this.$store.getters.getActiveCommunity.id,
          memberId: this.$store.getters.getActiveCommunity.member_id
        });
      }
      this.pollsFilter = !this.pollsFilter;
    },
    async getPollsForAllCommunities() {
      if (this.pollsFilter) {
        await this.getAllPolls();
      } else {
        const communities = this.$store.getters.getCommunities;
        const communitiesData = [];
        for (const community of communities) {
          communitiesData.push({
            memberId: community.member_id,
            communityId: community.community_id
          });
        }

        await this.getAllPolls(communitiesData);
      }
      this.pollsFilter = !this.pollsFilter;
    }
  }
};
</script>
<style scoped lang="scss">
.body-wrapper {
  display: block;
  padding: 10px;
}

.table-wrapper {
  position: relative;
}

.VuePagination {
  display: none;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}

.btn {
  background: var(--primary-color);
  color: white;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.btn:focus {
  box-shadow: none;
}

.polls-filter {
  top: 3.4rem;
  left: 0rem;
  z-index: 999;
}
</style>
